import EmploymentInfoComponent from './EmploymentInfoContainer';

export default EmploymentInfoComponent